import { http } from '../../../api/axios';
import { shopPrefix } from '../../../config';
import { ProductsResponseOut } from '../../../store/api';
import { Pagination } from '../../../../models/Pagination';

type ParameterTypes = {
    filterMap: string;
    pagination: Pagination;
    loanFormat?: string;
    ageCategory?: string;
    shopLanguage?: string;
};

export const fetchCampaignProducts = ({
    filterMap,
    pagination,
    ageCategory,
    loanFormat,
    shopLanguage
}: ParameterTypes) => {
    return http
        .post<ProductsResponseOut>(`${shopPrefix}/v1/campaignproducts/allproducts/products`, filterMap, {
            params: {
                ...pagination,
                loanFormat,
                ageCategory,
                shopLanguage
            }
        })
        .then(response => response.data);
};
